import { useEffect, useState } from 'react';
import { Select, Space } from 'antd';
import { getAsociaciones, asignarAsociacion } from 'services/Asociaciones';
import { routesNames } from 'utils/Constants';
import { useAuth } from "hooks/useAuth";

const Asociaciones = ({ defaultValue, cuenta }) => {
    const [asociaciones, setAsociaciones] = useState([])
    const [asociacionSeleccionada, setAsociacionSeleccionada] = useState(null)
    const { userData } = useAuth()

    useEffect(() => {
        obtenerAsociaciones()
        console.log(cuenta)
    }, [])

    async function obtenerAsociaciones() {
        const data = await getAsociaciones()
        const opciones = data.map(item => ({
            value: item.id,
            label: item.nombre
        }))
        setAsociaciones(opciones)
    }

    const handleChange = value => {
        setAsociacionSeleccionada(value)
    }

    const asignar = async () => {

        const dataAsoc = {
            cuenta_id: cuenta,
            asociacion_id: asociacionSeleccionada == undefined || asociacionSeleccionada == "" ? null : asociacionSeleccionada
        }

        try {
            await asignarAsociacion(dataAsoc).then((response) => {
                if (response) {
                    window.location.reload();
                } else {
                    console.error(response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Space wrap>
                <Select
                    name="asociacion"
                    placeholder="Asociaciones"
                    allowClear
                    showSearch
                    size="large"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    options={asociaciones}
                    defaultValue={defaultValue}
                />

                <button onClick={asignar} className='bg-main text-sm px-6 font-bold py-2 rounded-lg hover:opacity-80' type='button'>
                    {asociacionSeleccionada == undefined || asociacionSeleccionada == "" ? "Guardar" : "Asignar"}
                </button>
            </Space>

            <a href={routesNames.ASOCIACIONES} target="_blank" className='text-yellow-500'>
                Administrar asociaciones
            </a>
        </>
    )
}

export default Asociaciones;
